import Cookie from 'js-cookie';
import { isAfter } from 'date-fns';
import {
  USER_ACCESS_COOKIE,
  USER_TYPE,
  getBrokerFederalId
} from '@plataforma/utils';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';
import { getUserProfile } from '@services/auth';

const getUser = () => {
  const { broker } = Cookie.getJSON(USER_ACCESS_COOKIE) || {};
  return broker.user ? broker.user : {};
};

export async function resumeQuote({ id, modalityId, createdAt }, v3Settings) {
  const brokerFederalId = await getBrokerFederalId();
  const user = getUser();
  const {
    active,
    modalities,
    releaseForEveryone,
    brokersWithPermission,
    profiles
  } = v3Settings;
  const migratedModality = modalities.find(item => item.id === modalityId);
  const url =
    user.userTypeDescription === USER_TYPE.policyholder
      ? `quote/modalities-express/${id}`
      : `modalities-express/${id}`;
  if (
    active &&
    migratedModality &&
    isAfter(new Date(createdAt), new Date(migratedModality.activatedAt)) &&
    (releaseForEveryone || brokersWithPermission.includes(brokerFederalId)) &&
    profiles.includes(getUserProfile())
  ) {
    window.location = `${getSessionItem('PLATAFORMA_V3')}/${id}`;
  } else {
    window.location = `${getSessionItem('PLATAFORMA_URL')}${url}`;
  }
}
